import { Schema as S } from "effect";

// The SDK client unwraps the vendor `{ meta, data }` envelope and raises
// `meta.errors` as exceptions, so this schema describes the payload (`data`).
export const PostPartnerScheduleResponseSchema = S.Array(S.Struct({ _id: S.String }));

export type PostPartnerScheduleResponse = S.Schema.Type<typeof PostPartnerScheduleResponseSchema>;
